"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rootStyles = exports.ToggleButtonGroupBase = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _constants = require("../button/constants");

var _context = require("../context");

var _utils = require("../utils");

var _constants2 = require("./constants");

var _interfaces = require("./interfaces");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ToggleButtonScreenSize;

(function (ToggleButtonScreenSize) {
  ToggleButtonScreenSize["Normal"] = "Normal";
  ToggleButtonScreenSize["Small"] = "Small";
})(ToggleButtonScreenSize || (ToggleButtonScreenSize = {}));

var rootStyles = {
  '--st-group-button-width': '1px',
  '--st-group-button-focus-width': '2px',
  '--st-group-button-stacked-width': '0px'
};
exports.rootStyles = rootStyles;
var ToggleButtonGroupBase = (0, _context.styledWithTheme)('fieldset')(function (_ref) {
  var _borderRadius, _radiusFirst, _radiusLast, _firstOutlineStyle, _lastOutlineStyle, _ref2, _ref3;

  var hasSingleChild = _ref.hasSingleChild,
      isInReflow = _ref.isInReflow,
      layout = _ref.layout,
      _ref$theme = _ref.theme,
      selectors = _ref$theme.selectors,
      mediaQueries = _ref$theme.mediaQueries;
  var focusBorderColor = selectors.color('primary70');
  var borderRadius = (_borderRadius = {}, (0, _defineProperty2.default)(_borderRadius, ToggleButtonScreenSize.Normal, (0, _utils.px)(selectors.radius('R1000'))), (0, _defineProperty2.default)(_borderRadius, ToggleButtonScreenSize.Small, (0, _utils.px)(selectors.radius('R300'))), _borderRadius);
  var smallRadius = selectors.radius('R100');
  var fillGap = {
    color: selectors.color('neutral0'),
    width: 1
  };
  var radiusFirst = (_radiusFirst = {}, (0, _defineProperty2.default)(_radiusFirst, ToggleButtonScreenSize.Normal, [borderRadius[ToggleButtonScreenSize.Normal], 0, 0, borderRadius[ToggleButtonScreenSize.Normal]]), (0, _defineProperty2.default)(_radiusFirst, ToggleButtonScreenSize.Small, [borderRadius[ToggleButtonScreenSize.Small], borderRadius[ToggleButtonScreenSize.Small], 0, 0]), _radiusFirst);
  var radiusLast = (_radiusLast = {}, (0, _defineProperty2.default)(_radiusLast, ToggleButtonScreenSize.Normal, [0, borderRadius[ToggleButtonScreenSize.Normal], borderRadius[ToggleButtonScreenSize.Normal], 0]), (0, _defineProperty2.default)(_radiusLast, ToggleButtonScreenSize.Small, [0, 0, borderRadius[ToggleButtonScreenSize.Small], borderRadius[ToggleButtonScreenSize.Small]]), _radiusLast);
  var firstOutlineStyle = (_firstOutlineStyle = {}, (0, _defineProperty2.default)(_firstOutlineStyle, ToggleButtonScreenSize.Normal, (0, _utils.addOutline)(_constants.OUTLINE_WIDTH, _constants.OUTLINE_OFFSET, focusBorderColor, fillGap, radiusFirst[ToggleButtonScreenSize.Normal].map(function (r) {
    return r === 0 ? (0, _utils.px)(smallRadius) : r;
  }).join(' '), {
    zIndex: 1
  })), (0, _defineProperty2.default)(_firstOutlineStyle, ToggleButtonScreenSize.Small, (0, _utils.addOutline)(_constants.OUTLINE_WIDTH, _constants.OUTLINE_OFFSET, focusBorderColor, fillGap, radiusFirst[ToggleButtonScreenSize.Small].map(function (r) {
    return r === 0 ? (0, _utils.px)(smallRadius) : r;
  }).join(' '), {
    zIndex: 1
  })), _firstOutlineStyle);
  var othersOutlineStyle = (0, _utils.addOutline)(_constants.OUTLINE_WIDTH, _constants.OUTLINE_OFFSET, focusBorderColor, fillGap, smallRadius, {
    zIndex: 1
  });
  var lastOutlineStyle = (_lastOutlineStyle = {}, (0, _defineProperty2.default)(_lastOutlineStyle, ToggleButtonScreenSize.Normal, (0, _utils.addOutline)(_constants.OUTLINE_WIDTH, _constants.OUTLINE_OFFSET, focusBorderColor, fillGap, radiusLast[ToggleButtonScreenSize.Normal].map(function (r) {
    return r === 0 ? (0, _utils.px)(smallRadius) : r;
  }).join(' '), {
    zIndex: 1
  })), (0, _defineProperty2.default)(_lastOutlineStyle, ToggleButtonScreenSize.Small, (0, _utils.addOutline)(_constants.OUTLINE_WIDTH, _constants.OUTLINE_OFFSET, focusBorderColor, fillGap, radiusLast[ToggleButtonScreenSize.Small].map(function (r) {
    return r === 0 ? (0, _utils.px)(smallRadius) : r;
  }).join(' '), {
    zIndex: 1
  })), _lastOutlineStyle);
  var typeSelectors = [':first-of-type', ':last-of-type'];
  var firstTypeSelector = typeSelectors[0],
      lastTypeSelector = typeSelectors[1];
  var restTypesSelector = typeSelectors.map(function (t) {
    return ":not(".concat(t, ")");
  }).join('');
  return _objectSpread({
    display: 'flex',
    flexDirection: 'row',
    border: 'none',
    '& > button': !hasSingleChild ? (_ref2 = {}, (0, _defineProperty2.default)(_ref2, restTypesSelector, {
      borderRadius: 0,
      borderLeftWidth: 0,
      ':focus-visible': _objectSpread({}, othersOutlineStyle.focus)
    }), (0, _defineProperty2.default)(_ref2, firstTypeSelector, {
      borderRadius: radiusFirst[ToggleButtonScreenSize.Normal].join(' '),
      ':focus-visible': firstOutlineStyle[ToggleButtonScreenSize.Normal].focus
    }), (0, _defineProperty2.default)(_ref2, lastTypeSelector, {
      borderRadius: radiusLast[ToggleButtonScreenSize.Normal].join(' '),
      borderLeftWidth: 0,
      ':focus-visible': lastOutlineStyle[ToggleButtonScreenSize.Normal].focus
    }), _ref2) : undefined
  }, (isInReflow || layout === _interfaces.ToggleButtonGroupLayout.Vertical) && mediaQueries.sm({
    flexDirection: 'column',
    '& > button': !hasSingleChild ? (_ref3 = {}, (0, _defineProperty2.default)(_ref3, restTypesSelector, {
      borderLeftWidth: _constants2.BORDER_WIDTH,
      borderTopWidth: 0,
      ':focus-visible': {
        borderTopWidth: 0
      }
    }), (0, _defineProperty2.default)(_ref3, firstTypeSelector, {
      borderRadius: radiusFirst[ToggleButtonScreenSize.Small].join(' '),
      ':focus-visible': firstOutlineStyle[ToggleButtonScreenSize.Small].focus
    }), (0, _defineProperty2.default)(_ref3, lastTypeSelector, {
      borderRadius: radiusLast[ToggleButtonScreenSize.Small].join(' '),
      borderLeftWidth: _constants2.BORDER_WIDTH,
      borderTopWidth: 0,
      ':focus-visible': lastOutlineStyle[ToggleButtonScreenSize.Small].focus
    }), _ref3) : 0
  }));
});
exports.ToggleButtonGroupBase = ToggleButtonGroupBase;